import { formatPrice } from 'ui-seeker/utils'

// Dashboard prices (Competition, Parity, Packages) are shown as whole numbers: rounded to the nearest unit
// (Intl halfExpand) and always grouped by thousands — es-ES does not group 4-digit numbers by default
// (6941 €), the dashboards show 6.941 €. Browsers without useGrouping 'always' read it as true.
const INTEGER_PRICE_CONFIG = { decimals: 0, useGrouping: 'always' }

// Same N/A contract as formatPrice: falsy → 'N/A' unless displayZero.
// A non-zero amount under 0,50 prints 0 € (Intl would print -0 € for negatives).
export const formatIntegerPrice = (price, { displayZero = false, ...config } = {}) => {
    const NACriteria = displayZero ? price === null || price === undefined : !price
    if (NACriteria) return formatPrice(price, { displayZero, ...config })

    const value = Math.abs(price) < 0.5 ? 0 : price
    return formatPrice(value, { ...config, ...INTEGER_PRICE_CONFIG, displayZero: true })
}

// react-countup props for an animated integer price. displayZero: the animation starts at 0, which would
// otherwise flash 'N/A'. Without currency the card shows a plain number, as with currencyInfoByCode.
export const integerPriceCountUpProps = currency => currency
    ? { formattingFn: v => formatIntegerPrice(v, { currency, displayZero: true }) }
    : {}
